import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const TRANSLATION_GROUP_AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS = Symbol('affiliate-program.sub-affiliate-deals');

export const AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_ROUTE_NAME = Symbol('affiliate-program.sub-affiliate-deals');
export const AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_LIST_ROUTE_NAME = Symbol('affiliate-program.sub-affiliate-deals.list');

export const AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_LIST_API_URL = 'admin/subaffiliate_conditions/list';
export const AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_LIST_QUERY_KEY = 'affiliate-program.sub-affiliate-deals.list';

export const AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_PERMISSIONS = {
  SHOW: new Permission(PermissionsList.admin.SUBAFFILIATECONDITIONS_SHOW),
  EDIT: new Permission(PermissionsList.admin.SUBAFFILIATECONDITIONS_EDIT),
  DELETE: new Permission(PermissionsList.admin.SUBAFFILIATECONDITIONS_DELETE),
};
